import { IDropdownOption } from "@fluentui/react";
import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { StateModel } from "../models/AddressModel";
import { StateService } from "../services/StateService";

export function useStateVM() {
    const service = new StateService();

    const [list, setList] = useState<StateModel[]>([]);
    const [listHash, setListHash] = useState<number>(0);

    const [options, setOptions] = useState<IDropdownOption[]>([]);

    const getList = () => {
        setList([]);
        setListHash(Utils.getRandomKey());

        const request = service.getList();
        DataUtils.onRequest(request, onGetListResult);
    }

    const onGetListResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success && result.data) {
            const states = result.data as StateModel[];
            setList(states);
            setOptions(parseOptions(states));
            setListHash(Utils.getRandomKey());
        }
    }

    const parseOptions = (states: StateModel[]) => {
        return states.map((state: StateModel) => {
            return {
                key: state.id,
                text: state.nameKh
            };
        });
    }

    return {
        list,
        listHash,
        options,
        getList
    }
}